import { SubmissionError } from 'redux-form';
import { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';
import { saveInstantRentApplicationInfoSuccess, saveInstantRentApplicationInfoFail } from '../../actions/apartments';
import { addFormSubmit, addStepCompletion } from '../../config/googleTagManager';
import { selectBeforeLoginApartment } from '../../selectors/apartments';
import Api from '../../services/applications';
import i18n from '../../translations/i18n';
import { BeforeLoginApartment } from '../../types/apartments';
import { InstantRentAuthInformation } from '../../types/applications';
import { InstantRentInfoParameters } from '../../types/formData';
import { InstantRentCreationSteps, StepCompletionEventNames } from '../../types/GTM';
import { handleInitializeBeforeLoginApartment } from './beforeLoginApartments';
export function* handleSaveInstantRentInfo({ payload: { formData, resolve, reject } }: InstantRentInfoParameters): SagaIterator {
    try {
        let instantRentWithNewInfo: BeforeLoginApartment | undefined = yield select(selectBeforeLoginApartment);
        if (!instantRentWithNewInfo) {
            yield call(handleInitializeBeforeLoginApartment);
            instantRentWithNewInfo = yield select(selectBeforeLoginApartment);
            if (!instantRentWithNewInfo) {
                throw new Error('Apartment missing from state and could not initialize beforeLoginApartment');
            }
        }
        const { readyForMoveDate, movingWithAmount } = formData;
        const formInformation: InstantRentAuthInformation = {
            ...formData
        };
        const { movingWithAmount: MWAmount = '' } = JSON.parse(localStorage.getItem('authInfo') || '[]');
        const { code: applicationCode = '', applicants } = JSON.parse(localStorage.getItem('application') || '[]');
        const { code: apartmentCode = '' } = JSON.parse(localStorage.getItem('apartment') || '[]');
        // console.log('movingWithAmount', movingWithAmount?.value)
        const reqInformation: InstantRentAuthInformation = {
            ...formInformation,
            acceptedTc: formInformation.acceptedTc,
            movingWithAmount: movingWithAmount?.value === undefined
                ? MWAmount
                : movingWithAmount?.value,
            readyForMoveDate: new Date(readyForMoveDate),
            language: localStorage.getItem('language') || 'en',
            applicationCode: applicationCode,
            apartmentCode: apartmentCode,
            addApplicant: applicants && applicants.length !== 0
        };
        const authResponse = yield call(Api.updateInstantRent, reqInformation);
        yield put(saveInstantRentApplicationInfoSuccess(authResponse));
        resolve();
        window.location.replace(authResponse?.authenticationUrl);
        // don't send GTM data for admin actions
        // if (!isAlreadyConfirmed) {
        addFormSubmit('instantRentInfo');
        addStepCompletion(StepCompletionEventNames.instantRentCreation, InstantRentCreationSteps.getAuthUrl);
    }
    catch (error: any) {
        // alert(JSON.stringify(error))
        yield put(saveInstantRentApplicationInfoFail((error as any).message));
        yield call(reject, new SubmissionError({ _error: i18n.t('apartment.actions.formFail') }));
    }
}
